import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Card, CardBody, Collapse, Col, Row } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import { PreloadState, Or } from "../../UI/preloading/PreloadState";
import SectionHeader from "./../SectionHeader";
import Section from "../../common/Section";
import bg from "../../../assets/img/illustrations/6.png";

const QAs = ({ question, answer, divider = true }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <>
      <h6>
        <Button
          className="bg-transparent shadow-none border-0 p-0"
          onClick={toggle}
        >
          <p className="mb-0 text-primary fs-0">
            {question}
            <FontAwesomeIcon
              className="text-primary ml-2"
              icon={!isOpen ? "caret-right" : "caret-down"}
            />
          </p>
        </Button>
      </h6>
      <Collapse isOpen={isOpen}>
        <p className="fs--1 mb-0">{answer}</p>
      </Collapse>
      {divider && <hr className="my-3" />}
    </>
  );
};

QAs.propTypes = {
  question: PropTypes.string,
  answer: PropTypes.string,
  divider: PropTypes.bool,
};


const Questions = ({ faqs = [], seeAll, setSeeAll }) => {
  if (faqs.length <= 4) return faqs.map((faq, i) => <QAs {...faq} key={i} />);
  else {
    if (!seeAll)
      return faqs
        .filter((faq, i) => i < 4)
        .map((faq, i) => <QAs {...faq} key={i} />);
    else return faqs.map((faq, i) => <QAs {...faq} key={i} />);
  }
};

Questions.propTypes = {
  faqs: PropTypes.array,
};


const Faq = () => {
  const { user } = useSelector((state) => state.auth);
  const [seeAll, setSeeAll] = useState(false);

  const { role } = user || {};

  const faqs = [
    {
      question: "¿Cómo puedo registrarme en la plataforma?",
      answer: "El registro debe ser realizado por la entidad designada como ente administrador de condominio, este puede ser una persona, grupo de personas o incluso una empresa destinada a ejercer este tipo de funciones. Una vez registrado el administrador, este, podrá generar de forma automática, las cuentas de los propietarios existentes para cada condominio, y sus respectivas credenciales, que de forma posterior puede ser modificadas por parte del propietario."
    },
    {
      question: "¿Cómo administrador puedo gestionar más de un condominio?",
      answer:
        "Si, Homelan, permite para el administrador, el manejo de múltiples condominios manejando de forma independiente la información.",
    },
    {
      question: "¿El registro el gratuito?",
      answer:
        "Si, Homelan solo realiza cobros al momento de registrar como administrador un condominio y establece el monto basado en las tarifas de Homelan.",
    },
    {
      question: "¿Cómo se calcula la tarifa de cobro?",
      answer:
        "Con base en las propiedades, cada condominio, manejará una tarifa basada en la cantidad de propiedades que posea.",
    },
    {
      question: "¿Homelan genera las cuotas de cobro de forma automatizada?",
      answer:
        "Si, el administrador de condominio, puede configurar los parámetros respectivos para realizar los cobros a propietarios de forma automatizada.",
    },
    {
      question: "¿Homelan genera recibos en los módulos de cobro y pagos?",
      answer:
        "Si, en Homelan, todo movimiento financiero va acompañado de su recibo.",
    },
    {
      question:
        "¿La información del condominio es compartida entre propietarios?",
      answer:
        "Si, Homelan ofrece transparencia en la información del condominio que debe estar disponible para todos los propietarios, como finanzas, áreas comunes, seguridad y más.",
    },
    {
      question: "¿Hay un espacio de comunicación en tiempo real y público?",
      answer:
        "Si, en Homelan existe un módulo de publicaciones donde se puede compartir información entre todos los usuarios de un condominio.",
      divider: false,
    },
  ];

  return (
    <Section id="faq" bg="light" className={`text-center py-5 my-2`}>
      <SectionHeader
        title="Preguntas frecuentes"
        subtitle="A continuación, encontrará respuestas a las preguntas más frecuentes"
      />
      <Row className="p-2 mt-4 py-4 justify-content-between align-items-center">
        <Col
          sm={4}
          className="card-span-img col-sm-4 d-flex align-items-center justify-content-center"
        >
          <img src={bg} alt="faq" width={"100%"} />
        </Col>
        <Col sm={8}>
          <Card style={{ transform: "rotate(3deg)" }}>
            <CardBody>
              <PreloadState cond={!!role}>
                <Or value={true}>
                  <>Preguntas para los roles</>
                </Or>
                <Or value={false}>
                  <>
                    <Questions
                      faqs={faqs}
                      seeAll={seeAll}
                      setSeeAll={setSeeAll}
                    />
                    <Button
                      className="btn-block border-0 shadow-none text-primary"
                      color="falcon-default"
                      onClick={() => setSeeAll(!seeAll)}
                    >
                      {seeAll ? "Ver menos" : "Ver más preguntas..."}
                    </Button>
                  </>
                </Or>
              </PreloadState>
            </CardBody>
            {/* <CardFooter className="d-flex align-items-center bg-light">
                    <Button onClick={e => history.goBack()} color="falcon-default" size="md">
                      <FontAwesomeIcon icon={faUndo} className='mr-1' />
                      Volver
                    </Button>
                  </CardFooter> */}
          </Card>
        </Col>
      </Row>
    </Section>
  );
};

export default Faq;
